<template>
    <div class="row mt-3" v-if="ready">
        <div class="col-12">
            <div class="form-label">Metrics Preview</div>
        </div>

        <div class="col-12">
            <apexchart
                type="bar"
                :options="chartOptions"
                :series="series"
                height="340"
            ></apexchart>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { debounce } from 'lodash';

export default {
    components: {
        apexchart: VueApexCharts,
    },

    props: ['goal', 'metrics'],

    data () {
        return {
            ready: true,
            series: [
                {
                    name: '',
                    data: [],
                },
            ],
            chartOptions: {
                colors: ['#0f3266', '#00afc5', '#ff0059', '#0db4e6', '#8997aa'],
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                },
                plotOptions: {
                    bar: {
                        vertical: true,
                    },
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ['#fff'],
                },
                title: {
                    text: '',
                },
                xaxis: {
                    title: {
                        text: 'Metrics',
                    },
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Goal Target Number',
                    },
                    forceNiceScale: true,
                    min: 0,
                    labels: {
                        formatter: function (val) {
                            return parseInt(val.toFixed(1));
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
                legend: {
                    position: 'bottom',
                },
            },
        };
    },

    watch: {
        metrics: {
            deep: true,
            handler () {
                this.resetChart();
                this.updateChartPreview();
            },
        },

        goal: {
            deep: true,
            handler () {
                this.resetChart();
                this.updateChartPreview();
            },
        },
    },

    methods: {
        updateChartPreview: debounce(function () {
            if (!!this.goal.name && !!this.goal.number) {
                const goalNumber = parseInt(this.goal.number);
                this.chartOptions.yaxis.max = goalNumber;
                this.chartOptions.yaxis.tickAmount = goalNumber < 10 ? goalNumber : null;

                this.metrics.map(item => {
                    if (!!item.name && !!item.number_hits) {
                        const numberHits = parseInt(item.number_hits);
                        const metricName = item.name;

                        this.series[0].data.push(numberHits);
                        this.chartOptions.xaxis.categories.push(metricName);

                        if (numberHits > goalNumber) {
                            this.chartOptions.yaxis.max = numberHits;
                            this.chartOptions.yaxis.tickAmount = numberHits < 10 ? numberHits : null;
                        }
                    }
                });
            }

            this.ready = this.series[0].data.length > 0;
        }, 1000),

        resetChart () {
            this.ready = false;
            this.series[0].data = [];
            this.chartOptions.xaxis.categories = [];
        },
    },
};
</script>

<style scoped lang="scss">
.form-label {
    font-weight: 400 !important;
}
</style>
